import React from 'react';
import classnames from 'classnames';
import Text from '../text/text';
import { OptionIcon, OptionIconChecked } from './option-icon';

import './oe-radio-options.scss';

type OERadioSingleOptionProps = {
    option?: { label?: string; id?: string };
    value: string | number | boolean | null;
    checked?: boolean;
    onToggle?: (value?: string | number | boolean | null) => void;
    disabled?: boolean;
    width?: string;
    allowUncheck?: boolean;
};

const OERadioSingleOption: React.FunctionComponent<OERadioSingleOptionProps> = (props: OERadioSingleOptionProps): JSX.Element => {
    const {onToggle, allowUncheck, option, checked, value, width, disabled} = props;
    const handleOnCheck = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (disabled) return;
        if (checked && !allowUncheck) return;
        if (onToggle) {
            onToggle(checked ? null : value);
        }
    };

    return (
        <div className='oe-radio-option__options'>
            <div
                key={`${value}`}
                className={classnames('oe-radio-option', {'oe-radio-option--selected': checked})}
                style={{width: width ? width : 'auto'}}
                onClick={handleOnCheck}
            >
                <input
                    type='radio'
                    id={`radio-button-${value}`}
                    className='oe-radio-option__control'
                    defaultChecked={checked}
                    readOnly={disabled}
                />
                <label htmlFor={`radio-button-${value}`} className='oe-radio-option__label'>
                    {checked ? <OptionIconChecked /> : <OptionIcon />}
                    { option &&
                        <Text
                            className={classnames('oe-radio-option__label-text', {
                                'oe-radio-option__label-text--disabled': props.disabled
                            })}
                            id={option.id}
                            message={option.label}
                            description='Join by button text'
                            withEllipsis
                        />
                    }
                </label>
            </div>
        </div>
    );
};

OERadioSingleOption.defaultProps = {
    disabled: false,
    allowUncheck: false,
    checked: false
};

export { OERadioSingleOption };

